import { buildUUID } from '@/utils/uuid';
import { setUUid } from '@/utils/auth';

export function isJSON(str) {
    if (typeof str == 'string') {
        try {
            var obj = JSON.parse(str);
            if (typeof obj == 'object' && obj) {
                return true;
            } else {
                return false;
            }

        } catch (e) {
            console.log('error：' + str + '!!!' + e);
            return false;
        }
    }
    console.log('It is not a string!')
}

export function toLink() {
    sessionStorage.clear()
    const uuid = buildUUID();
    setUUid(uuid);
    const href = `https://authserver.nuaa.edu.cn/authserver/login?service=http%3A%2F%2Fclass101.nuaa.edu.cn%2Fapi%2Fuser%2FcasLogin?uuid=${uuid}`;
    // const href = `http://localhost:8080/cas-server-webapp-tomcat-5.3.16/login?service=http://localhost:8084/api/user/casLogin?uuid=${uuid}`;
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = href;
    a.click();
    document.body.removeChild(a);

  }
  